module.exports = __webpack_public_path__ + "static/media/instagram.523a20e5.svg";